import Showable from '~/Controller/Showable'

/**
 * Dropdown controller for dropdown/toggle functionality
 * Extends Showable for consistent behavior
 */
export default class Dropdown extends Showable {
	static props = {
		...Showable.props,
		active: false,
		exclusiveGroup: true,
		outClickHide: true,
		escHide: true,
		trigger: 'click',
		activeClass: '--active',
		focusOnShow: false,
		urlHashShow: false,
		urlHashRemove: false,
		documentClassing: false,
		scrollHide: true,
		duration: 300,
	}

	onShow(event) {
		super.onShow(event)

		const otherOpenDropdowns = document.querySelectorAll('details[data-controller="dropdown"][open]')
		const hasOtherOpen = Array.from(otherOpenDropdowns).some(dropdown => dropdown !== this.element)

		if (hasOtherOpen) {
			const subList = this.element.querySelector('.m-header__nav__sub__list')
			if (subList) {
				subList.classList.add('--switching')
				setTimeout(() => {
					subList.classList.remove('--switching')
				}, 50)
			}
		}
	
		this.element.setAttribute('open', '')

		if (this.isSidebarNav) {
			window.requestAnimationFrame(() => {
				this.setSidebarNavHeight()
			})
		}
		
		this.closeOtherDropdowns()
		this.controlTargets.forEach(t => (t.ariaExpanded = 'true'))
	}

	onHide(event) {
		super.onHide(event)

		if (this.isSidebarNav) {
			this.setSidebarNavHideHeight()
		}


		if (event.detail.transition) {
			this.element.setAttribute('open', '')
			setTimeout(() => {
				this.element.removeAttribute('open')
			}, this.duration)
		} else {
			this.element.removeAttribute('open')
		}

		this.controlTargets.forEach(t => (t.ariaExpanded = 'false'))
	}
	

	setSidebarNavHeight() {
		if (!this.isSidebarNav) return
		const subList = this.element.querySelector('.m-sidebar-nav__sub__list')
		if (subList) {
			subList.style.height = `${subList.scrollHeight}px`
		}
	}
	
	setSidebarNavHideHeight() {
		if (!this.isSidebarNav) return
		const subList = this.element.querySelector('.m-sidebar-nav__sub__list')
		if (subList) {
			subList.style.height = '0px'
		}
	}

	closeOtherDropdowns() {
		const allDropdowns = document.querySelectorAll('details[data-controller="dropdown"]')

		allDropdowns.forEach(dropdown => {
			if (dropdown !== this.element) {
				const subList = dropdown.querySelector('.m-header__nav__sub__list')

				if (subList) {
					subList.classList.add('--switching')
					setTimeout(() => {
						subList.classList.remove('--switching')
					}, 50)
				}
				dropdown.removeAttribute('open')
			}
		})
	}

	connected() {
		this.isSidebarNav = this.element.closest('.m-sidebar-nav') !== null

		if (this.isSidebarNav) {
			this.duration = 250
		}

		if (this.active) {
			this.element.setAttribute('open', '')
			if (this.isSidebarNav) {
				this.setSidebarNavHeight()
			}
		} else if (this.isSidebarNav) {
			this.setSidebarNavHideHeight()
		}

		this.controlTargets.forEach(control => {
			control.setAttribute('aria-expanded', this.active ? 'true' : 'false')
		})

		super.connected()
	}

	disconnected() {
		super.disconnected()
		this.controlTargets.forEach(control => {
			control.removeAttribute('aria-expanded')
		})
	}
}